<div class="textareaComponent" [ngClass]="{'sinMargen' : sinMargen, 'soloLectura' : disabled}">


  <textarea [(ngModel)]="valor" name="textarea{{id}}" autosize #modeloArea="ngModel" (blur)="internalEventHandler(valor)" class="textareaCustom"
            placeholder="{{placeholder}}" required [maxLength]="maxLength"
            [ngClass]="{'is-filled': (modeloArea.value || modeloArea.value === 0), 'inputDeshabilitado' : disabled, 'mayusculas' : uppercase}"> </textarea>
  <label>{{titulo}}</label>


  <span class="textoError"  [hidden]="disabled || !verError || modeloArea.valid || (!modeloArea.touched && !errorActivo)">
     {{(mensajeError ? mensajeError : 'DatoIncompeto') | translate}}
  </span>
</div>
